import React, { useContext, useEffect } from 'react'
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Home from './app/Home'
import { authContext } from '../configurations/auth/authContext';
import Login from './auth/Login';
import ForgetPassword from './auth/ForgetPassword';
import CreateAccount from './auth/CreateAccount';
import ViewFastNotes from './app/fastNotes/ViewFastNotes';
import ForgotPin from './app/settings/ForgotPin';
import Profile from './app/settings/Profile';
import ChangePin from './app/settings/ChangePin';
import ChangePassword from './app/settings/ChangePassword';
import CenterAllByUser from './app/opdcenter/CenterAllByUser';
import CenterAllByUserPublic from './app/opdcenter/CenterAllByUserPublic';
import CenterById from './app/opdcenter/CenterById';
import Centers from './app/opdcenter/Centers';
import EditCenter from './app/opdcenter/EditCenter';
import AddCenter from './app/opdcenter/AddCenter';
import StartOPD from './app/opdlive/StartOPD';
import DoctorDisplay from './app/opdlive/DoctorDisplay';
import Reception from './app/opdlive/Reception';
import Display from './app/opdlive/Display';
import ChatConnection from './app/opdlive/liveconnection/ChatConnection';
import OpdRegister from './app/opdRegistered/OPDRegister';
import GetAllByUser from './app/rechargeHistory/GetAllByUser';
import { RechargePlansDashboard } from './app/settings/RechargePlans/RechargePlansDashboard';
import Public from '../Public';
import { UploadDP } from './app/settings/Settings/UploadDP';
import { RechargeSmsDashboard } from './app/settings/rechargeSmsPlans/RechargeSmsDashboard';
import DashBoard from './app/DashBoard';
import About from './app/About';
import Terms from './app/Terms';
import CheckRegistered from './app/CheckRegistered';
import CheckConfiremd from './app/CheckConfirmed';
import Contact from './app/Contact';
import Privacy from './app/Privacy';
import Team from './app/Team';
import Error404 from './app/Error404';
import LookOut from './app/opdlive/LookOut';
import RoleSelection from './app/publicUsers/ViewPublicUser';
import { IsMobileEnv } from '../configurations/initUrls';
import PublicUserOAuth from './app/publicUsers/PublicUserOAuth';
import useAuth from '../configurations/auth/publicUsers/useAuth';
import MyRegister from './app/publicUsers/MyRegister';
import MyConfirmed from './app/publicUsers/MyConfirmed';
import useRegisterPushPublic from '../configurations/push/pushNotificationPublic';
import useRegisterPush from '../configurations/push/pushNotification';
import { Capacitor } from '@capacitor/core';
import Favorites from './app/publicUsers/Favorites';

export default function RouterContainer() {
    const [isLogin, setIsLogin] = useContext(authContext);
    const location = useLocation();
    const regPub = useRegisterPushPublic()
    const { handleRegister, handleRegisterDoctor } = useRegisterPush()
    const { authentication } = useAuth()

    useEffect(() => {
        regPub.handleRegister()
    }, [])

    useEffect(() => {
        if (authentication?.isLogin) {
            if (Capacitor.isNativePlatform()) {
                handleRegister();
            }
        }
    }, [authentication?.isLogin]);

    useEffect(() => {
        if (isLogin) {
            if (Capacitor.isNativePlatform()) {
                handleRegisterDoctor();
            }
        }
    }, [isLogin]);

    return (
        <Routes>
            {isLogin ?
                <>
                    <Route path='/home' Component={DashBoard} />
                    <Route path='/fastnotes/view' Component={ViewFastNotes} />
                    <Route path='/change-password' Component={ChangePassword} />
                    <Route path='/change-pin' Component={ChangePin} />
                    <Route path='/forgot-pin' Component={ForgotPin} />
                    <Route path='/profile' Component={Profile} />
                    <Route path='/uploaddp' Component={UploadDP} />

                    <Route path='/opdcenters' Component={Centers} />
                    <Route path='/opdcenters/:centerid/view' Component={CenterById} />
                    <Route path='/opdcenters/:centerid/edit' Component={EditCenter} />
                    <Route path='/opdcenters/add' Component={AddCenter} />

                    <Route path='/display/:centerid/center' Component={Display} />
                    <Route path='/reception/:centerid/center' Component={Reception} />
                    <Route path='/doctor/:centerid/center' Component={DoctorDisplay} />
                    <Route path='/startopd' Component={StartOPD} />
                    <Route path='/lookout' Component={LookOut} />
                    <Route path='/opdregister' Component={OpdRegister} />
                    <Route path='/rechargehistory' Component={GetAllByUser} />
                    <Route path='/recharge' Component={RechargePlansDashboard} />
                    <Route path='/rechargesms' Component={RechargeSmsDashboard} />

                    <Route path='/opdcenter/all' Component={CenterAllByUser} />
                    <Route path='/opdcenter/center-allbyuserpublic' Component={CenterAllByUserPublic} />

                    <Route path='/checkregister' Component={CheckRegistered} />
                    <Route path='/checkregister/:id' Component={CheckRegistered} />
                    <Route path='/checkconfirmed' Component={CheckConfiremd} />
                    <Route path='/checkconfirmed/:id' Component={CheckConfiremd} />
                    <Route path='/doctor/:doctorId' element={<CenterAllByUserPublic />} />
                    <Route path='/center/:centerId' element={<CenterById />} />

                    <Route path='/about' Component={About} />
                    <Route path='/terms' Component={Terms} />
                    <Route path='/contact' Component={Contact} />
                    <Route path='/privacy' Component={Privacy} />
                    <Route path='/team' Component={Team} />
                    <Route path='/404' Component={Error404} />


                    <Route path='/' element={<Navigate to="/home" replace />} />
                    <Route path='*' element={<Navigate to="/home" replace />} />
                </>
                :
                !IsMobileEnv || authentication.isLogin ? <>
                    <Route path='/' Component={Home} />
                    <Route path='/favorite' Component={Favorites} />
                    <Route path='/about' Component={About} />
                    <Route path='/terms' Component={Terms} />
                    <Route path='/contact' Component={Contact} />
                    <Route path='/privacy' Component={Privacy} />
                    <Route path='/team' Component={Team} />
                    <Route path='/doctor/:doctorId' element={<CenterAllByUserPublic />} />
                    <Route path='/center/:centerId' element={<CenterById />} />
                    <Route path='/login' Component={Login} />
                    <Route path='/checkregister' Component={CheckRegistered} />
                    <Route path='/myregister' Component={MyRegister} />
                    <Route path='/myregister/:phoneNo' Component={MyRegister} />
                    <Route path='/myconfirmed' Component={MyConfirmed} />
                    <Route path='/myconfirmed/:phoneNo' Component={MyConfirmed} />
                    <Route path='/checkregister/:id' Component={CheckRegistered} />
                    <Route path='/checkconfirmed' Component={CheckConfiremd} />
                    <Route path='/checkconfirmed/:id' Component={CheckConfiremd} />
                    {/* <Route path='/chat' Component={ChatConnection} /> */}
                    <Route path='/create-doctor' Component={CreateAccount} />
                    <Route path='/forgot' Component={ForgetPassword} />
                    <Route path='/404' Component={Error404} />

                    <Route path='*' element={<Navigate to="/" replace />} />
                </>
                    :
                    <>
                        <Route path='/' Component={RoleSelection} />
                        <Route path='/login' Component={Login} />
                        <Route path='/create-doctor' Component={CreateAccount} />
                        <Route path='/forgot' Component={ForgetPassword} />
                        <Route path='/public-login' Component={PublicUserOAuth} />
                        <Route path='/about' Component={About} />
                        <Route path='/terms' Component={Terms} />
                        <Route path='/contact' Component={Contact} />
                        <Route path='/privacy' Component={Privacy} />
                        <Route path='*' element={<Navigate to="/" replace />} />
                    </>
            }
        </Routes>
    )
}
